import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IgSelectionState {
  selectedIgId: string | null;
  selectedIgData: any | null;
}

const getSessionStorageItem = (key: string) => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const setSessionStorageItem = (key: string, value: string) => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Ignore errors
  }
};

const removeSessionStorageItem = (key: string) => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // Ignore errors
  }
};

const initialState: IgSelectionState = {
  selectedIgId: getSessionStorageItem('selected_ig_id') || null,
  selectedIgData: getSessionStorageItem('selected_ig_data') ? JSON.parse(getSessionStorageItem('selected_ig_data')!) : null,
};

export const igSelectionSlice = createSlice({
  name: 'igSelection',
  initialState,
  reducers: {
    setSelectedIgAccount: (state, action: PayloadAction<{ igId: string; igData: any }>) => {
      state.selectedIgId = action.payload.igId;
      state.selectedIgData = action.payload.igData;
      setSessionStorageItem('selected_ig_id', action.payload.igId);
      setSessionStorageItem('selected_ig_data', JSON.stringify(action.payload.igData));
    },
    clearIgSelection: (state) => {
      state.selectedIgId = null;
      state.selectedIgData = null;
      removeSessionStorageItem('selected_ig_id');
      removeSessionStorageItem('selected_ig_data');
    },
    resetIgSelection: () => initialState,
  },
});

export const { setSelectedIgAccount, clearIgSelection, resetIgSelection } = igSelectionSlice.actions;
export default igSelectionSlice.reducer;